import { appInsights } from "../AppInsights";

const queryHeaderFooter = async (endpoint = "", responseType) => {
  try {
    const result = await fetch(
      `${process.env.REACT_APP_HEADERFOOTER_ENDPOINT}${endpoint}`,
      {
        headers: {
          accepts: responseType,
          "Access-Control-Max-Age": 86400,
          "Ocp-Apim-Subscription-Key": process.env.REACT_APP_HEADERFOOTER_APIM_KEY
        }
      }
    ).then(response => {
      if (!response.ok) throw new Error(`${endpoint} fetch failed.`);
      return responseType === "application/json"
        ? response.json()
        : response.text();
    });
    return result;
  } catch (error) {
    appInsights?.trackException({ exception: `${error} Failed to retrieve headerFooter.` });
    return { error };
  }
};

const logError = error => {
  return false;
};
const AppUserAgents = {
  Android: "ALKApp/Android",
  iOS: "ALKApp/iOS",
  Header: "NativeHeader"
};

export function isFromMobileWebView() {
  return (
    window.navigator.userAgent.includes(AppUserAgents.Android) || window.navigator.userAgent.includes(AppUserAgents.iOS)
  );
}

export function isNativeHeader() {
  return (
    window.navigator.userAgent.includes(AppUserAgents.Header)
  );
}


const mountHeaderFooter = async () => {
  if (!isFromMobileWebView()) {
    const htmlJson = await queryHeaderFooter(
      `headerfooter?var=loyalty`,
      "application/json"
    );

    if (htmlJson.error) {
      return logError(htmlJson.error);
    }

    if (htmlJson.header) {
      const wrapper = document.createElement('div');
      wrapper.innerHTML = htmlJson.header;
      const scripts = wrapper.querySelectorAll('script');
      scripts.forEach((script) => {
        const newScript = document.createElement('script');
        if (script.src) {
          newScript.src = script.src;
        } else {
          newScript.textContent = script.textContent;
        }
        document.body.appendChild(newScript);
      });
    }

    return htmlJson;
  }
  return true;
};

export { mountHeaderFooter };